<template>
  <div id="vouchTable">
    <table>
      <thead>
        <tr v-if="!tableShow">
          <th rowspan="2" class="noBorder" width="25"></th>
          <th rowspan="2" width="218">摘要</th>
          <th rowspan="2" width="352">会计科目</th>
          <th width="243" colspan="11">借方金额</th>
          <th width="243" colspan="11">贷方金额</th>
        </tr>
        <tr v-else>
          <th rowspan="2" class="noBorder" width="25"></th>
          <th rowspan="2" width="140">摘要</th>
          <th rowspan="2" width="252">会计科目</th>
          <th width="255" rowspan="2">{{ colunm }}</th>
          <th width="202" colspan="11">借方金额</th>
          <th width="202" colspan="11">贷方金额</th>
        </tr>
        <tr class="unit">
          <td colspan="11">
            <div class="moneyUtil">
              <span
                v-for="(item, index) in dw"
                :key="index"
                :class="getClassName(item, index)"
              >
                {{ item }}
              </span>
            </div>
          </td>
          <td colspan="11">
            <div class="moneyUtil">
              <span
                v-for="(item, index) in dw"
                :key="index"
                :class="getClassName(item, index)"
              >
                {{ item }}
              </span>
            </div>
          </td>
        </tr>
      </thead>
      <!-- 凭证主题内容 -->
      <tbody>
        <tr v-for="(item, ins) in datas" :key="ins + 'd'">
          <td class="noBorder">
            <div class="tipBtn">
              <i
                class="el-icon-plus"
                @click="addListPz1(ins)"
                title="新增一条"
              ></i>
              <i
                class="el-icon-delete"
                @click="delListPz(ins)"
                title="删除当前"
              ></i>
            </div>
          </td>
          <td>
            <div class="zyFunction relatve">
              <!-- 摘要模板 -->
              <zy-template
                :zyText="item.summary"
                :perv="ins > 0 ? datas[ins - 1].summary : ''"
                :inputFocus="item.inputFocus ? item.inputFocus : false"
                :zyList="listLabel.zylistArr"
                @on-push-summary="getSummary($event, ins)"
                @on-enter-keyDown="enterDownMethods($event, 'summary', ins)"
                @on-tab-focusChange="enterDownMethods($event, 'summary', ins)"
              ></zy-template>
              <el-button
                type="text"
                class="zyBtn"
                @click.stop="openSummary(ins)"
                :style="{
                  display:
                    item.summary && item.summary !== 0 ? 'block' : 'none',
                }"
                >摘要</el-button
              >
            </div>
          </td>
          <td>
            <div class="zyFunction relatve">
              <!-- 科目模板 -->
              <km-template
                :kmText="item"
                :inputFocus="item.inputFocus ? item.inputFocus : false"
                :kmlist="subjectList"
                :XG_voucherShows="XG_voucherShows"
                @on_success_info="handleOnSuccessInfo"
                @on-push-objects="getKmchange($event, ins)"
                @on-enter-keyDown="enterDownMethods($event, 'subject', ins)"
                @on-tab-focusChange="
                  enterDownMethods($event, 'subject', ins, 'tab')
                "
                @on-mask-visible="maskVisable"
              ></km-template>

              <el-button
                type="text"
                class="llBtn"
                :style="{ color: item.fkCashFlowIds ? '#409EFF' : '#666' }"
                @click.stop="FlowDialogOpen(item, ins)"
                v-if="
                  (item.isFlowBtnShow || (item.id && item.flowButton != 2)) &&
                  item.fkSubjectId
                "
              >
                流量
              </el-button>
              <el-button
                type="text"
                class="zyBtn"
                @click.stop="subjectTreeOpen(ins)"
                :style="{ display: item.fkSubjectId ? 'block' : 'none' }"
                >科目</el-button
              >
            </div>
          </td>
          <td v-show="tableShow">
            <sl-template
              :slObj="item"
              :inputFocus="item.inputFocus ? item.inputFocus : false"
              @on-push-slForeign="slChanges($event, ins)"
              @on-enter-keyDown="enterDownMethods($event, 'slAuxiliary', ins)"
              @on-tab-focusChange="
                enterDownMethods($event, 'slAuxiliary', ins, 'tab')
              "
            ></sl-template>
          </td>
          <td colspan="11">
            <!-- 借方金额计算 -->
            <money-count
              :num="item.debitMoney"
              :inputFocus="item.inputFocus ? item.inputFocus : false"
              tip="debitMoney"
              :direction="item.direction"
              @on-push-money="updataMoney($event, 'debitMoney', ins)"
              @on-trial-balance="trialBalanceNum($event, 'debitMoney', ins)"
              @on-enter-keyDown="enterDownMethods($event, 'debitMoney', ins)"
              @on-money-changes="moneysChanges($event, 'debitMoney', ins)"
              @on-tab-focusChange="
                enterDownMethods($event, 'debitMoney', ins, 'tab')
              "
            ></money-count>
          </td>
          <td colspan="11">
            <!-- 贷方金额计算 -->
            <money-count
              :num="item.creditorMoney"
              :inputFocus="item.inputFocus ? item.inputFocus : false"
              tip="creditorMoney"
              :direction="item.direction"
              @on-push-money="updataMoney($event, 'creditorMoney', ins)"
              @on-trial-balance="trialBalanceNum($event, 'creditorMoney', ins)"
              @on-enter-keyDown="enterDownMethods($event, 'creditorMoney', ins)"
              @on-money-changes="moneysChanges($event, 'creditorMoney', ins)"
              @on-tab-focusChange="
                enterDownMethods($event, 'creditorMoney', ins, 'tab')
              "
            ></money-count>
          </td>
        </tr>
        <!-- 凭证主题结束 -->
        <tr height="56">
          <td class="noBorder"></td>
          <td
            colspan="3"
            align="left"
            class="numMoney"
            v-if="tableShow ? true : false"
          >
            合计:{{ numMoneyT }}
          </td>
          <td colspan="2" align="left" class="numMoney" v-else>
            合计:{{ numMoneyT }}
          </td>

          <td colspan="11">
            <money-count :num="mumMoney" :edit="true"></money-count>
          </td>
          <td colspan="11">
            <money-count :num="mumMoney1" :edit="true"></money-count>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="creatDlist" v-if="auditStatus">
      审核人: <span>{{ userName }}</span>
      <img src="/static/img/examine.png" alt="已审核" />
    </p>
    <p class="creatDlist" v-else>
      制单人: <span>{{ userName }}</span>
    </p>

    <!-- 新增摘要modal -->
    <el-dialog
      title="凭证摘要库"
      :visible.sync="pz.pzDialog"
      width="420px"
      append-to-body
      :close-on-click-modal="false"
      class="handleDialogS"
    >
      <div class="pzDialog">
        <div class="clearfix addPZZY">
          <span class="fl"
            >摘要内容
            <!-- <span style="font-size: 12px;color: red;">(双击选择)</span> --></span
          >
          <el-button
            class="fr minButton"
            size="mini"
            v-show="pz.turnInput"
            @click="addAbstract"
            >+ 新增摘要</el-button
          >
          <el-input
            placeholder="请输入摘要"
            class="fr"
            v-model="pz.inpVal"
            size="mini"
            v-show="!pz.turnInput"
            ref="inputsDia"
            @blur="abstractBlur"
            @keyup.enter.native="abstractBlur"
          ></el-input>
        </div>
        <div class="tagWarp">
          <el-tag
            closable
            v-for="(item, index) in pz.tagList"
            :key="index"
            @close="closeTags(item)"
            @click.native="enterTags(item)"
            style="cursor: pointer"
          >
            {{ item.content }}
          </el-tag>
        </div>
      </div>
      <div slot="footer" class="dialog-footer-right">
        <el-button @click="pz.pzDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 选中科目modal -->
    <el-dialog
      append-to-body
      title="科目"
      :visible.sync="km.modal"
      width="430px"
      :close-on-click-modal="false"
      class="default-dialog handleDialogS"
    >
      <div v-loading="km.loading">
        <el-tabs v-model="km.tabs" @tab-click="tabHandle">
          <el-tab-pane
            v-for="(item, index) in listLabel.typelist"
            :key="index"
            :label="item"
            :name="item"
          ></el-tab-pane>
        </el-tabs>
        <div
          style="width: 100%; max-height: 500px; overflow-y: auto"
          class="cus__treeRow"
        >
          <el-tree
            :data="km.data"
            :porps="defaultProps"
            :expand-on-click-node="false"
            @node-click="HandleNodeClick"
            @dblclick.native="HandleNodeDClick"
          ></el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer-right">
        <el-button size="small" @click="km.modal = false">取消</el-button>
        <el-button size="small" class="minButton" @click="enterKMtree"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!--现金流量配置-->
    <distribution-flow-dialog
      :isFlowDialogShow.sync="isFlowDialogShow"
      :rowMessage="rowMessage"
      @flowIds="flowIds"
    ></distribution-flow-dialog>
  </div>
</template>

<script>
import zyTemplate from "@/components/table/zyTemplate";
import kmTemplate from "@/components/table/kmTemplate";
import slTemplate from "@/components/table/slTemplate";
import moneyCount from "@/components/table/moneyCount";
import { chineseNumbers } from "@/assets/utils/dom";
import distributionFlowDialog from "@/components/dialog/distributionFlowDialog";

export default {
  props: [
    "kmDate",
    "clearAble",
    "exmine",
    "superData_fapiao",
    "XG_voucherShows",
  ],
  data() {
    return {
      isAdd:false,
      rowMessage: {}, // 当前行信息
      isFlowDialogShow: false, // 流量分配表是否显示
      index: 0,
      colunm: "数量核算",
      dw: ["亿", "千", "百", "十", "万", "千", "百", "十", "元", "角", "分"],
      jjTip: true,
      defaultProps: {
        label: "name",
      },

      pz: {
        pzDialog: false,
        turnInput: true,
        inpVal: "",
        tagList: [],
      },
      km: {
        modal: false,
        loading: false,
        tabs: "",
        data: [],
        datas: {},
      },
      tableShow: false,
      inputFocus: {
        //获取input焦点Enter
        zyInputFocus: false,
        subInputFocus: false,
        slInputFocus: false,
        slEndInputFocus: false,
        deInputFocus: false,
        crInputFocus: false,
      },
      datas: [
        {
          isFlowBtnShow: false, // 是否显示流量按钮
          summary: "", //摘要
          fkSubjectId: "", //科目ID
          subjectVo: {
            name: "",
            code: "",
            nums: 0,
            oney: 0,
          },
          debitMoney: 0, //借方金额
          creditorMoney: 0, //贷方金额
          //bankHappenDate:'',			//银行发生时间
          auxiliaryAccountingIds: "", //所有辅助核算ids
          fkForeignCurrencyId: "", //外币IDs
          debitAmount: 0, //借方数量核算
          creditorAmount: 0, //贷方数量核算
          unit: 0, //科目核算中的单价
          exchangerate: 0, //汇率
          debitCoin: 0, //借方原币
          creditorCoin: 0, //贷方原币
        },
        {
          isFlowBtnShow: false, // 是否显示流量按钮
          summary: "", //摘要
          fkSubjectId: "", //科目ID
          subjectVo: {
            name: "",
            code: "",
            nums: 0,
            oney: 0,
          },
          debitMoney: 0, //借方金额
          creditorMoney: 0, //贷方金额
          //bankHappenDate:'',			//银行发生时间
          auxiliaryAccountingIds: "", //所有辅助核算ids
          fkForeignCurrencyId: "", //外币IDs
          debitAmount: 0, //借方数量核算
          creditorAmount: 0, //贷方数量核算
          unit: 0, //科目核算中的单价
          exchangerate: 0, //汇率
          debitCoin: 0, //借方原币
          creditorCoin: 0, //贷方原币
        },
        {
          isFlowBtnShow: false, // 是否显示流量按钮
          summary: "", //摘要
          fkSubjectId: "", //科目ID
          subjectVo: {
            name: "",
            code: "",
            nums: 0,
            oney: 0,
          },
          debitMoney: 0, //借方金额
          creditorMoney: 0, //贷方金额
          //bankHappenDate:'',			//银行发生时间
          auxiliaryAccountingIds: "", //所有辅助核算ids
          fkForeignCurrencyId: "", //外币IDs
          debitAmount: 0, //借方数量核算
          creditorAmount: 0, //贷方数量核算
          unit: 0, //科目核算中的单价
          exchangerate: 0, //汇率
          debitCoin: 0, //借方原币
          creditorCoin: 0, //贷方原币
        },
        {
          isFlowBtnShow: false, // 是否显示流量按钮
          summary: "", //摘要
          fkSubjectId: "", //科目ID
          subjectVo: {
            name: "",
            code: "",
            nums: 0,
            oney: 0,
          },
          debitMoney: 0, //借方金额
          creditorMoney: 0, //贷方金额
          //bankHappenDate:'',			//银行发生时间
          auxiliaryAccountingIds: "", //所有辅助核算ids
          fkForeignCurrencyId: "", //外币IDs
          debitAmount: 0, //借方数量核算
          creditorAmount: 0, //贷方数量核算
          unit: 0, //科目核算中的单价
          exchangerate: 0, //汇率
          debitCoin: 0, //借方原币
          creditorCoin: 0, //贷方原币
        },
      ],
      numMoneyT: "",
      mumMoney: 0,
      mumMoney1: 0,

      listLabel: {
        typelist: [],
        zylistArr: [],
      },
      template: {
        isFlowBtnShow: false, // 是否显示流量按钮
        summary: "", //摘要
        fkSubjectId: "", //科目ID
        subjectVo: {
          name: "",
          code: "",
          nums: 0,
          oney: 0,
        },
        debitMoney: 0, //借方金额
        creditorMoney: 0, //贷方金额
        //bankHappenDate:'',			//银行发生时间
        auxiliaryAccountingIds: "", //所有辅助核算ids
        fkForeignCurrencyId: "", //外币IDs
        debitAmount: 0, //借方数量核算
        creditorAmount: 0, //贷方数量核算
        unit: 0, //科目核算中的单价
        exchangerate: 0, //汇率
        debitCoin: 0, //借方原币
        creditorCoin: 0, //贷方原币
      },
      userName: "", //制单人or审核人
      auditStatus: false, //审核状态
      subjectList: [],
    };
  },
  components: {
    zyTemplate,
    kmTemplate,
    slTemplate,
    moneyCount,
    distributionFlowDialog,
  },
  created() {
    this.getAllSummary();
    this.init();
  },
  computed: {},
  methods: {
    // 选择的现金流量表ID
    flowIds(data) {
      this.$set(this.datas[this.index], "fkCashFlowIds", data);
    },
    // 打开现金流量
    FlowDialogOpen(row, index) {
      // if((!row.summary && row.summary !== 0) || (row.debitMoney == 0 && row.creditorMoney == 0)) {
      // 	return this.$message.warning('请完善当前分录以完成流量分配！')
      // }
      this.index = index;
      this.isFlowDialogShow = true; // 打开流量表
      row.yearPeriods =
        this.exmine && this.exmine.id ? this.exmine.yearPeriods : "";
      this.rowMessage = row;
    },
    // status 为true时则代表需要刷新科目列表
    init(status) {
      const _ = this;
     if(this.subjectList.length && !status)  return;   // 不知道这里为什么调用这么多次，暂时觉得判断有长度之后就不用请求了，ljc  2023-08-10
      _.$http.post("subject/getSujectByContent", {}).then((res) => {
        if (res && res.data.code == "1") {
          this.subjectList = res.data.data;
        }
      });
    },
    handleOnSuccessInfo(data) {
      if (data) {
        this.init(true);
      }
    },
    // 重置当前表格
    resetTable() {
      this.datas = [
        {
          isFlowBtnShow: false, // 是否显示流量按钮
          summary: "", //摘要
          fkSubjectId: "", //科目ID
          subjectVo: {
            name: "",
            code: "",
            nums: 0,
            oney: 0,
          },
          debitMoney: 0, //借方金额
          creditorMoney: 0, //贷方金额
          //bankHappenDate:'',			//银行发生时间
          auxiliaryAccountingIds: "", //所有辅助核算ids
          fkForeignCurrencyId: "", //外币IDs
          debitAmount: 0, //借方数量核算
          creditorAmount: 0, //贷方数量核算
          unit: 0, //科目核算中的单价
          exchangerate: 0, //汇率
          debitCoin: 0, //借方原币
          creditorCoin: 0, //贷方原币
        },
        {
          isFlowBtnShow: false, // 是否显示流量按钮
          summary: "", //摘要
          fkSubjectId: "", //科目ID
          subjectVo: {
            name: "",
            code: "",
            nums: 0,
            oney: 0,
          },
          debitMoney: 0, //借方金额
          creditorMoney: 0, //贷方金额
          //bankHappenDate:'',			//银行发生时间
          auxiliaryAccountingIds: "", //所有辅助核算ids
          fkForeignCurrencyId: "", //外币IDs
          debitAmount: 0, //借方数量核算
          creditorAmount: 0, //贷方数量核算
          unit: 0, //科目核算中的单价
          exchangerate: 0, //汇率
          debitCoin: 0, //借方原币
          creditorCoin: 0, //贷方原币
        },
        {
          isFlowBtnShow: false, // 是否显示流量按钮
          summary: "", //摘要
          fkSubjectId: "", //科目ID
          subjectVo: {
            name: "",
            code: "",
            nums: 0,
            oney: 0,
          },
          debitMoney: 0, //借方金额
          creditorMoney: 0, //贷方金额
          //bankHappenDate:'',			//银行发生时间
          auxiliaryAccountingIds: "", //所有辅助核算ids
          fkForeignCurrencyId: "", //外币IDs
          debitAmount: 0, //借方数量核算
          creditorAmount: 0, //贷方数量核算
          unit: 0, //科目核算中的单价
          exchangerate: 0, //汇率
          debitCoin: 0, //借方原币
          creditorCoin: 0, //贷方原币
        },
        {
          isFlowBtnShow: false, // 是否显示流量按钮
          summary: "", //摘要
          fkSubjectId: "", //科目ID
          subjectVo: {
            name: "",
            code: "",
            nums: 0,
            oney: 0,
          },
          debitMoney: 0, //借方金额
          creditorMoney: 0, //贷方金额
          //bankHappenDate:'',			//银行发生时间
          auxiliaryAccountingIds: "", //所有辅助核算ids
          fkForeignCurrencyId: "", //外币IDs
          debitAmount: 0, //借方数量核算
          creditorAmount: 0, //贷方数量核算
          unit: 0, //科目核算中的单价
          exchangerate: 0, //汇率
          debitCoin: 0, //借方原币
          creditorCoin: 0, //贷方原币
        },
      ];
    },
    subjectTreeOpen(k) {
      const _ = this;
      _.index = k;
      _.km.modal = true;
      _.km.datas = {};
      _.getAllSubjectType();
    },

    //获取科目树
    getTreeSubject() {
      const _ = this;
      _.km.loading = true;
      _.$http
        .post("subject/ajaxgetTree", {
          type: _.km.tabs == 0 ? "资产" : _.km.tabs,
        })
        .then((res) => {
          _.km.loading = false;
          if (res && res.data.code == "1") {
            var datas = res.data.data;
            let list = _.getTreeData(datas);
            _.km.data = list;
          }
        })
        .catch(() => {
          _.km.loading = false;
        });
    },
    getTreeData(list) {
      for (let i = 0; i < list.length; i++) {
        list[i].label = list[i].code + " " + list[i].name;
        if (list[i].children && list[i].children.length > 0) {
          this.getTreeData(list[i].children);
        }
      }
      return list;
    },
    //获取科目类别
    getAllSubjectType() {
      const _ = this;
      _.km.loading = true;
      let datas = {
        cid: _.cid,
      };
      _.$http
        .post("subject/getSubjectType", datas)
        .then((res) => {
          _.km.loading = false;
          if (res && res.data.code == "1") {
            _.getTreeSubject();
            _.listLabel.typelist = res.data.data;
            _.km.tabs = res.data.data[0];
          }
        })
        .catch(() => {
          _.km.loading = false;
        });
    }, //科目树
    tabHandle(val) {
      this.km.tabs = val.name;
      this.getTreeSubject();
    },
    HandleNodeDClick() {
      const _ = this;
      if (_.km.datas.children && _.km.datas.children.length > 0) {
        _.$message({
          message: "不能选择父级科目!",
          type: "error",
        });
      } else {
        _.datas[_.index].subjectVo = _.km.datas;
        _.km.modal = false;
      }
    },
    HandleNodeClick(data) {
      const _ = this;
      _.km.datas = data;
    },
    enterKMtree() {
      const _ = this;
      if (_.km.datas.children && _.km.datas.children.length > 0) {
        _.$message({
          message: "不能选择父级科目!",
          type: "error",
        });
      } else if (_.km.datas.id) {
        _.datas[_.index].subjectVo = _.km.datas;
        this.datas[_.index].subjectName = _.km.datas.label;
        _.km.modal = false;
      } else {
        _.$message({
          message: "您还没选择科目!",
          type: "error",
        });
      }
    }, //摘要返回
    getSummary(val, index) {
      const _ = this;
      _.datas[index].summary = val;
    }, //科目会计 返回
    getKmchange(val, index) {
      const _ = this;
      if (val.cashFlowButton) {
        _.datas[index].isFlowBtnShow = true;
      } else {
        _.datas[index].isFlowBtnShow = false;
      }
      _.datas[index].subjectVo = val;
      _.datas[index].subjectNames = val.subjectNames;
      _.datas[index].fkSubjectId = val.id ? val.id : "";
      if(val.select && !this.isAdd) {
        // 清除属性
        _.datas[index].debitAmount = 0;
        _.datas[index].creditorAmount = 0;
        _.datas[index].unit = "0";
      }
      if (val.auxiliaryAccountingIds !== undefined) {
        _.datas[index].auxiliaryAccountingIds = val.auxiliaryAccountingIds
          ? val.auxiliaryAccountingIds
          : "";
      }

      _.init();
      //科目发生变化时 应该情况数量核算中的值
    }, //数量核算 返回
    slChanges(val, index) {
      const _ = this;
      if(this.tableShow) {
        _.datas[index].unit = val.unit; //单价
      }else {
        _.datas[index].unit = "0"; //单价
      }
      _.$set(_.datas[index].subjectVo, "nums", val.nums); //余额
      _.datas[index].fkForeignCurrencyId = val.fkForeignCurrencyId; //原币IDS
      _.datas[index].exchangerate = val.exchangerate; //汇率0
      if (val.none != "none") {
        ///如果贷方金额 借方金额都为空时 则根据科目判断
        if (
          _.datas[index].debitMoney == 0 &&
          _.datas[index].creditorMoney == 0
        ) {
          if (_.datas[index].subjectVo.creditDirection == "借") {
            _.datas[index].debitAmount = val.debitAmount;
            _.datas[index].creditorAmount = 0;

            _.datas[index].debitCoin = val.debitCoin;
            _.datas[index].creditorCoin = 0;

            _.datas[index].debitMoney = val.money;
          } else {
            _.datas[index].creditorAmount = val.creditorAmount;
            _.datas[index].debitAmount = 0;

            _.datas[index].creditorCoin = val.creditorCoin;
            _.datas[index].debitCoin = 0;

            _.datas[index].creditorMoney = val.money;
          }
        } else {
          if (_.datas[index].creditorMoney != 0) {
            // 贷方金额 不为0
            _.datas[index].creditorAmount = val.creditorAmount; //数量
            _.datas[index].debitAmount = 0; //数量

            _.datas[index].creditorCoin = val.creditorCoin; //原币
            _.datas[index].debitCoin = 0; //原币

            _.datas[index].creditorMoney = val.money;
          } else {
            _.datas[index].debitAmount = val.debitAmount;
            _.datas[index].creditorAmount = 0;

            _.datas[index].debitCoin = val.debitCoin;
            _.datas[index].creditorCoin = 0;

            _.datas[index].debitMoney = val.money;
          }
        }
      }
    },
    ////金额 贷方 借方 返回值
    updataMoney(data, key, index) {
      const _ = this;
      this.mumMoney = 0;
      this.mumMoney1 = 0;
      for (let i = 0; i < this.datas.length; i++) {
        this.mumMoney += this.datas[i].debitMoney;
        this.mumMoney1 += this.datas[i].creditorMoney;
      }
      if (this.mumMoney > 999999999.99) {
        this.mumMoney = 999999999.99;
      } else if (this.mumMoney1 > 999999999.99) {
        this.mumMoney1 = 999999999.99;
      }

      if (
        this.mumMoney &&
        this.mumMoney1 &&
        this.mumMoney.toFixed(2) == this.mumMoney1.toFixed(2)
      ) {
        if (this.mumMoney != 0) {
          this.numMoneyT = chineseNumbers(this.mumMoney);
        } else {
          this.numMoneyT = chineseNumbers(this.mumMoney1);
        }
      } else if (this.mumMoney == 0 && this.mumMoney1 == 0) {
        this.numMoneyT = "";
      } else {
        this.numMoneyT = "";
      }
      if (data != 0) {
        let d = JSON.parse(JSON.stringify(this.datas));

        let amount =d[index].creditorAmount? d[index].creditorAmount:d[index].debitAmount;
        let coin = d[index].creditorCoin ?d[index].creditorCoin:d[index].debitCoin;
        if (key == "debitMoney") {
          this.datas[index].debitAmount = amount;
          this.datas[index].creditorAmount = 0;
          this.datas[index].debitCoin = coin;
          this.datas[index].creditorCoin = 0;
        }
        if (key == "creditorMoney" && d[index].debitAmount != 0) {
          this.datas[index].debitAmount = 0;
          this.datas[index].creditorAmount = amount;
          this.datas[index].debitCoin = 0;
          this.datas[index].creditorCoin = coin;
        }
      }
      if (key == "debitMoney" && data != 0) {
        _.$set(_.datas[index], "debitMoney", data);
        _.$set(_.datas[index], "creditorMoney", 0);
      }
      if (key == "debitMoney" && data == 0) {
        _.$set(_.datas[index], "debitMoney", 0);
      }
      if (key == "creditorMoney" && data != 0) {
        _.$set(_.datas[index], "debitMoney", 0);
        _.$set(_.datas[index], "creditorMoney", data);
      }
      if (key == "creditorMoney" && data == 0) {
        _.$set(_.datas[index], "creditorMoney", 0);
      }

      _.$emit("on-voucher-total", {
        d_money: _.mumMoney,
        c_money: _.mumMoney1,
      });
    },
    // //新增凭证列表数据
    // addListPz(ins) {
    //   console.log(ins,this.datas)
    //   if (ins + 1 == this.datas.length) {
    //     this.addListPz1(ins);
    //   } else {
    //     // this.$set(this.datas,ins,JSON.parse(JSON.stringify(this.template)))
    //     this.datas.splice(ins+1, 0, JSON.parse(JSON.stringify(this.template)));
    //   }
    // },
    addListPz1(ins) {
      this.isAdd = true
      this.datas.splice(ins + 1, 0, JSON.parse(JSON.stringify(this.template)));
    },
    //删除凭证列表数据
    delListPz(ins) {
      this.isAdd = true
      let auxli = this.$store.state.loadstatus.auxliaryModal;
      if (auxli) {
        this.$message.error("请先选择辅助核算！");
        return false;
      }
      if (this.datas.length <= 4) {
        /* this.$message({
						message:'至少保留两条数据!',
						type:"warning"
					}); */
        this.datas.splice(ins, 1);
        this.datas.push(JSON.parse(JSON.stringify(this.template)));
      } else {
        this.datas.splice(ins, 1);
      }
    },
    addAbstract() {
      this.pz.turnInput = false;
      this.$nextTick(() => {
        this.$refs.inputsDia.focus();
      });
    }, //添加摘要
    abstractBlur() {
      const _ = this;
      if (this.pz.inpVal != "") {
        for (let i = 0; i < this.pz.tagList.length; i++) {
          if (this.pz.tagList[i].content == this.pz.inpVal) {
            this.$message({
              message: "已有相同的摘要,不能添加!",
              type: "warning",
            });
            return false;
          }
        }
        _.$http
          .post("summary/save", { content: this.pz.inpVal })
          .then((res) => {
            if (res && res.data.code == "1") {
              this.$message({ message: "新增摘要成功!", type: "success" });
              this.pz.turnInput = true;
              this.pz.inpVal = "";
              this.getAllSummary();
            }
          })
          .catch((e) => {
            this.$message({ message: "新增摘要失败!", type: "error" });
          });
      }
    }, ///删除摘要
    closeTags(val) {
      const _ = this;
      this.$confirm("是否删除这条摘要？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        this.pz.tagList.splice(val, 1);
        _.$http
          .post("summary/deleled", { id: val.id })
          .then((res) => {
            if (res && res.data.code == "1") {
              this.$message({ message: "删除摘要成功!", type: "error" });
              this.getAllSummary();
            }
          })
          .catch((e) => {
            this.$message({ message: "删除摘要成功!", type: "error" });
          });
      });
    }, //查询摘要
    getAllSummary() {
      const _ = this;
      _.$http
        .post("summary/getSummary", {})
        .then((res) => {
          if (res && res.data.code == "1") {
            _.pz.tagList = res.data.data;
            _.listLabel.zylistArr.splice(0);
            for (let i = 0; i < res.data.data.length; i++) {
              _.listLabel.zylistArr.push({
                value: res.data.data[i].content,
              });
            }
          }
        })
        .catch((e) => {});
    }, //查询所有摘要
    openSummary(k) {
      const _ = this;
      _.index = k;
      _.pz.pzDialog = true;
      _.getAllSummary();
    },
    enterTags(row) {
      const _ = this;
      _.datas[_.index].summary = row.content;
      _.pz.pzDialog = false;
    },
    getClassName(item, ins) {
      let className = "";
      if (ins == 2 || ins == 5) {
        className = "green";
      } else if (ins == 8) {
        className = "blue";
      }
      return className;
    }, //试算平衡计算
    trialBalanceNum(val, key, ins) {
      const _ = this;
      var allDebitMoney = 0;
      var allCreditorMoney = 0;
      for (let i = 0; i < _.datas.length; i++) {
        if (i != ins) {
          allDebitMoney += _.datas[i].debitMoney;
          allCreditorMoney += _.datas[i].creditorMoney;
        }
      }

      if (key == "debitMoney") {
        let money = allCreditorMoney - allDebitMoney;
        _.$set(_.datas[ins], "debitMoney", money);
        _.$set(_.datas[ins], "creditorMoney", 0);
      } else {
        let money = allDebitMoney - allCreditorMoney;
        _.$set(_.datas[ins], "debitMoney", 0);
        _.$set(_.datas[ins], "creditorMoney", money);
      }
      /////////=============== 试算完成 ========================//
    }, //enter TAb 键盘事件操作
    enterDownMethods(val, key, ins, meth) {
      const _ = this;
      let inp = JSON.parse(JSON.stringify(_.inputFocus));
      inp.slEndInputFocus = false;
      if (val) {
        switch (key) {
          case "summary":
            inp.subInputFocus = true;
            _.$set(_.datas[ins], "inputFocus", inp);
            break;
          case "subject":
            _.$nextTick(() => {
              if (
                _.datas[ins].subjectVo.numberAccounting ||
                _.datas[ins].subjectVo.foreignCurrency
              ) {
                inp.slInputFocus = true;
              } else {
                if (meth && meth == "tab") {
                  //当为Tab事件时切换
                  inp.deInputFocus = true;
                } else {
                  if (
                    _.datas[ins].creditorMoney == 0 &&
                    _.datas[ins].debitMoney == 0
                  ) {
                    if (_.datas[ins].subjectVo.creditDirection == "借") {
                      inp.deInputFocus = true;
                    } else {
                      inp.crInputFocus = true;
                    }
                  } else if (_.datas[ins].creditorMoney != 0) {
                    inp.crInputFocus = true;
                  } else if (_.datas[ins].debitMoney != 0) {
                    inp.deInputFocus = true;
                  } else {
                    inp.crInputFocus = true;
                  }
                }
              }
              _.$set(_.datas[ins], "inputFocus", inp);
            });
            break;
          case "slAuxiliary":
            if (meth && meth == "tab") {
              //当为Tab事件时切换
              inp.deInputFocus = true;
            } else {
              if (
                _.datas[ins].creditorMoney == 0 &&
                _.datas[ins].debitMoney == 0
              ) {
                if (_.datas[ins].subjectVo.creditDirection == "借") {
                  inp.deInputFocus = true;
                } else {
                  inp.crInputFocus = true;
                }
              } else if (_.datas[ins].creditorMoney != 0) {
                inp.crInputFocus = true;
              } else if (_.datas[ins].debitMoney != 0) {
                inp.deInputFocus = true;
              } else {
                inp.crInputFocus = true;
              }
            }
            _.$set(_.datas[ins], "inputFocus", inp);
            break;
          case "debitMoney":
            if (meth && meth == "tab") {
              //当为Tab事件时切换
              inp.crInputFocus = true;
              _.$set(_.datas[ins], "inputFocus", inp);
            } else {
              if (
                _.datas[ins].creditorMoney != 0 ||
                _.datas[ins].debitMoney != 0
              ) {
                inp.zyInputFocus = true;
                if (ins == _.datas.length - 1) {
                  //如果在最后一行则新增一行凭证
                  _.addListPz1(ins);
                }
                _.$set(_.datas[ins + 1], "inputFocus", inp);
              } else {
                inp.crInputFocus = true;
                _.$set(_.datas[ins], "inputFocus", inp);
              }
            }
            break;
          case "creditorMoney":
            if (
              _.datas[ins].creditorMoney != 0 ||
              _.datas[ins].debitMoney != 0
            ) {
              inp.zyInputFocus = true;
              if (ins == _.datas.length - 1) {
                //如果在最后一行则新增一行凭证
                _.addListPz1(ins);
              }
              _.$set(_.datas[ins + 1], "inputFocus", inp);
            } else {
              inp.crInputFocus = true;
              _.$set(_.datas[ins], "inputFocus", inp);
            }
            break;
        }
      } else {
        switch (key) {
          case "summary":
            if (ins != 0) {
              inp.crInputFocus = true;
              _.$set(_.datas[ins - 1], "inputFocus", inp);
            }
            break;
          case "subject":
            inp.zyInputFocus = true;
            _.$set(_.datas[ins], "inputFocus", inp);
            break;
          case "slAuxiliary":
            inp.subInputFocus = true;
            _.$set(_.datas[ins], "inputFocus", inp);
            break;
          case "debitMoney":
            if (
              _.datas[ins].subjectVo.foreignCurrency ||
              _.datas[ins].subjectVo.numberAccounting
            ) {
              inp.slInputFocus = true;
              inp.slEndInputFocus = true;
            } else {
              inp.subInputFocus = true;
            }
            _.$set(_.datas[ins], "inputFocus", inp);
            break;
          case "creditorMoney":
            inp.deInputFocus = true;
            _.$set(_.datas[ins], "inputFocus", inp);
            break;
        }
      }
    }, ///==========================  按下空格 进行贷方借方 金额交换焦点也交换
    moneysChanges(val, key, ins) {
      const _ = this;
      let inp = JSON.parse(JSON.stringify(_.inputFocus));
      let data = JSON.parse(JSON.stringify(_.datas[ins]));
      _.datas[ins].creditorMoney = data.debitMoney;
      _.datas[ins].debitMoney = data.creditorMoney;
      if (key == "debitMoney") {
        inp.crInputFocus = true;
      } else {
        inp.deInputFocus = true;
      }
      _.$set(_.datas[ins], "inputFocus", inp);
    },
    maskVisable(val) {
      //辅助核算遮罩层
      const _ = this;
      _.$emit("on-open-mask", val);
    },
  },
  activated() {
    // this.init();
  },
  watch: {
    datas: {
      handler(Val) {
        const _ = this;
        let bol = false;
        for (let i = 0; i < Val.length; i++) {
          //如果存在数量核算或者外币核算 则显示
          if (
            Val[i].subjectVo.foreignCurrency ||
            Val[i].subjectVo.numberAccounting
          ) {
            bol = true;
          }
          if (Val[i].subjectVo.numberAccounting) {
            _.colunm = "外币核算";
          } else {
            _.colunm = "数量核算";
          }
        }
        _.tableShow = bol;
        _.$emit("on-voucher-change", Val);
      },
      deep: true,
    },
    kmDate: {
      handler(Val) {
        if (Val) {
          const _ = this;
          let t = JSON.parse(JSON.stringify(_.template));
          let val = this.$lodash.cloneDeep(Val);
          if (val.length <= 4) {
            _.datas.splice(4);
          } else if (val.length > 4) {
            _.datas.splice(val.length);
          }
          for (let k = 0; k < _.datas.length; k++) {
            _.datas[k] = Object.assign(_.datas[k], t);
          }
          if (val && val.length > 0) {
            for (let i = 0; i < val.length; i++) {
              _.datas.splice(i, 1, val[i]);
              _.datas[i].isEditVoucher = true;
              _.datas[i].subjectVo.auxiliaryAccountingIds = val[i].auxiliaryAccountingIds;
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    clearAble(Val) {
      const _ = this;
      if (Val) {
        _.datas.splice(0);
        let t = JSON.parse(JSON.stringify(_.template));
        let arrs = [t, t, t, t];
        let arr = JSON.parse(JSON.stringify(arrs));
        _.datas = arr;
        _.$emit("clear-success", false);

        let inp = JSON.parse(JSON.stringify(_.inputFocus));
        inp.zyInputFocus = true;
        _.$set(_.datas[0], "inputFocus", inp);
      }
    },
    exmine: {
      handler(val) {
        if (val) {
          const _ = this;
          if (val.auditStatus == 1) {
            _.userName = val.auditPerson;
            _.auditStatus = true;
          } else {
            _.auditStatus = false;
            if (val.singlePerson && val.singlePerson != "") {
              _.userName = val.singlePerson;
            } else {
              _.userName = this.$getSessionStorage("user").account.userName;
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
    superData_fapiao: {
      handler(val) {
		// return
        if (
          val &&
          val.preVoucherAddendumList &&
          val.preVoucherAddendumList.length
        ) {
			let dataList = this.$lodash.cloneDeep(val.preVoucherAddendumList);
          dataList.forEach((i) => {
            i = Object.assign(i, {
              summary: i.summary, //摘要

              debitMoney: i.debitMoney ? i.debitMoney : 0, //借方金额
              creditorMoney: i.creditorMoney ? i.creditorMoney : 0, //贷方金额
              isFapiaoData: val.isGenerate ? false : true,
            });
          });
          this.datas = dataList;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import url("../../assets/css/voucherTable.less");
</style>



// WEBPACK FOOTER //
// src/components/table/voucherTable.vue